import { qs, listen, toggle } from '@fluorescent/dom';

import { section } from '@/glow';
import filterHandler from '@/lib/filters/filter-handler';
import filterDrawer from '@/lib/filters/filter-drawer';
import { AnimateSearch } from '@/lib/animation';
import ProductItem from '@/lib/product-item';

section('search', {
  onLoad() {
    const clearButton = qs('[data-clear-search]', this.container);
    const searchButton = qs('.search__submit', this.container);
    const searchInput = qs('[data-search-input]', this.container);
    const filterForm = qs('[data-filter-form]', this.container);

    if (filterForm) {
      const partial = qs('[data-partial]', this.container);

      this.filterDrawer = filterDrawer(this.container);
      this.filterHandler = filterHandler({
        container: this.container,
        partial: partial,
        renderCB: this._renderView.bind(this),
      });
    }

    if (searchInput) {
      toggle([clearButton, searchButton], 'visible', searchInput.value !== '');
    }

    this.productItem = ProductItem(this.container);
    this.AnimateSearch = AnimateSearch(this.container);

    this.events = [
      ...(clearButton && searchInput ? [
        listen(clearButton, 'click', () => {
          searchInput.value = '';
          toggle(
            [clearButton, searchButton],
            'visible',
            searchInput.value !== ''
          );
        }),
      ] : []),
      ...(searchInput ? [
        listen(searchInput, 'input', e =>
          toggle([clearButton, searchButton], 'visible', e.target.value !== '')
        ),
      ] : []),
    ];
  },

  _renderView(searchParams) {
    // Use full page navigation instead of AJAX fetch.
    // Shopify's CLI proxy does not reliably support ?section_id= on /search,
    // causing the fetch to hang and freeze the browser.
    // Since _renderView is only called from user interactions (Apply, Remove
    // filter, etc.), this will NOT cause a redirect loop on page load.
    const cleanParams = new URLSearchParams(searchParams);

    // Remove empty price range params to keep URL clean
    if (cleanParams.get('filter.v.price.gte') === '') cleanParams.delete('filter.v.price.gte');
    if (cleanParams.get('filter.v.price.lte') === '') cleanParams.delete('filter.v.price.lte');

    const url = `${window.location.pathname}?${cleanParams.toString()}`;
    window.location.assign(url);
  },

  onUnload() {
    this.filterHandler && this.filterHandler.unload();
    this.filterDrawer && this.filterDrawer.unload();
    this.AnimateSearch?.destroy();
    this.productItem && this.productItem.unload();
  },
});
